import { extent, range, ascending, rollup } from "d3-array";

function getItems(poems) {
  const itemsMap = new Map();

  const yearsExtent = extent(poems, d => d.year);
  const allConsecutiveYears = range(yearsExtent[0], yearsExtent[1] + 1);

  const poemsCountPerYear = rollup(
    poems,
    v => v.length,
    d => d.year
  );

  function addItem(type, value, key) {
    itemsMap.set(key, {
      type,
      value,
      key,
      values: allConsecutiveYears.map(year => ({
        year,
        count: 0
      }))
    });
  }

  function getItemKey(value, type) {
    return `${value} (${type})`;
  }

  poems.forEach(d => {
    d.themes.forEach(v => {
      const type = "theme";
      const value = v;
      const key = getItemKey(value, type);
      if (!itemsMap.has(key)) {
        addItem(type, value, key);
      }
      itemsMap.get(key).values.find(e => e.year === d.year).count++;
    });
    d.moods.forEach(v => {
      const type = "mood";
      const value = v;
      const key = getItemKey(value, type);
      if (!itemsMap.has(key)) {
        addItem(type, value, key);
      }
      itemsMap.get(key).values.find(e => e.year === d.year).count++;
    });
    d.motifs.forEach(v => {
      const type = "motif";
      const value = v;
      const key = getItemKey(value, type);
      if (!itemsMap.has(key)) {
        addItem(type, value, key);
      }
      itemsMap.get(key).values.find(e => e.year === d.year).count++;
    });
  });

  const orderedTypes = ["theme", "mood", "motif"];

  const items = [...itemsMap.values()].sort((a, b) => {
    if (a.type !== b.type) {
      return ascending(
        orderedTypes.indexOf(a.type),
        orderedTypes.indexOf(b.type)
      );
    } else {
      return ascending(a.value, b.value);
    }
  });

  items.forEach(d => {
    d.values.forEach(v => {
      const poemsCountThatYear = poemsCountPerYear.get(v.year);
      v.percentageYear = poemsCountThatYear ? v.count / poemsCountThatYear : 0;
      v.percentageTotal = v.count / poems.length;
    });
    Object.freeze(d.values);
  });

  return items;
}

export { getItems };
